export default {
  data: null,
  columns: [
    {
      label: '订单编号',
      prop: 'orderNo'
    },
    {
      label: '订单日期',
      prop: 'createTime'
    },
    {
      label: '教练姓名',
      prop: 'coachName'
    },
    {
      label: '教练手机号',
      prop: 'coachMobile'
    },
    {
      label: '学员姓名',
      prop: 'userName'
    },
    {
      label: '学员账号',
      prop: 'account'
    },
    {
      label: '日期',
      prop: 'subscribeDate'
    },
    {
      label: '时间段',
      prop: 'subscribeTime'
    },
    {
      label: '场地',
      prop: 'placeName'
    },
    {
      label: '支付金额',
      prop: 'amount'
    },
    {
      label: '退款比例',
      prop: 'refundRate'
    },
    {
      label: '退款金额',
      prop: 'refundAmount'
    },
    {
      label: '状态',
      prop: 'payStateName'
    },
    {
      label: '备注',
      prop: 'remark'
    }
  ]
}
